import React from 'react';

import MonacoEditor from 'llm/monaco/MonacoEditor';
import {MonacoLanguage} from 'llm/monaco/MonacoTypes';

interface CodeRendererProps {
  content: string;
  language: MonacoLanguage;
}

export default function CodeRenderer({content, language}: CodeRendererProps): JSX.Element {
  return (
    <MonacoEditor
      width="100%"
      height="100%"
      value={content}
      language={language}
      theme="vs"
      options={{readOnly: true, minimap: {enabled: false}}}
    />
  );
}
